import script from "./RoomControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomControl.vue?vue&type=script&setup=true&lang=ts"

import "./RoomControl.vue?vue&type=style&index=0&id=2433ca46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2433ca46"]])

export default __exports__